<template>
  <div class="mantenedor">
    <component :is="mantenedor" />
  </div>
</template>

<script>
import NoExiste from '@/views/NoExiste.vue'

export default {
  name: 'Mantenedor',
  components: {
    NoExiste,
    'mantenedor-bodegas': () =>
      import(
        /* webpackPrefetch: true */ '@/components/mantenedor/bodegas/Bodegas.vue'
      ),
    'mantenedor-sucursales': () =>
      import(
        /* webpackPrefetch: true */ '@/components/mantenedor/sucursales/Sucursales.vue'
      ),
    'mantenedor-terminales': () =>
      import(
        /* webpackPrefetch: true */ '@/components/mantenedor/terminales/Terminales.vue'
      ),
    'mantenedor-zonas': () =>
      import(
        /* webpackPrefetch: true */ '@/components/mantenedor/zonas/Zonas.vue'
      ),
    'mantenedor-usuarios': () =>
      import(
        /* webpackPrefetch: true */ '@/components/mantenedor/usuarios/Usuarios.vue'
      ),
    'mantenedor-tipos-entrega': () =>
      import(
        /* webpackPrefetch: true */ '@/components/mantenedor/tiposEntrega/TiposEntrega.vue'
      )
  },
  computed: {
    mantenedor() {
      const mantenedores = [
        'bodegas',
        'sucursales',
        'terminales',
        'zonas',
        'usuarios',
        'tipos-entrega'
      ]
      const mantenedor = this.$route.params.mantenedor.toLowerCase()
      if (mantenedores.includes(mantenedor)) return `mantenedor-${mantenedor}`
      return NoExiste
    }
  }
}
</script>
